import { TReactSetState, TUseTranslationTfn } from "../../data/AppType";
import {
  handleError,
  prepareMessageFromParams,
  sweetAlertError,
  sweetAlertSuccess,
} from "../../utils/AppFunctions";
import * as Yup from "yup";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";

import { BIT_VALUE } from "../../utils/AppEnumerations";
import {
  CREATE_GALLERY_DIRECTORY,
  GET_GALLERY_DIRECTORY_BY_ID,
  UPDATE_GALLERY_DIRECTORY,
} from "../../services/Endpoints";

export interface IGalleryDirectoryData {
  folder_name: string;
  gender: string;
  folder_image: string | null;
  id?: string;
}

export const GALLERY_DIRECTORY_INITIAL_VALUES = {
  folder_name: "",
  gender: "",
  is_active: BIT_VALUE.One,
  folder_image: "",
};

export const galleryDirectoryValidationSchema = (t: TUseTranslationTfn) =>
  Yup.object().shape({
    folder_name: Yup.string()
      .required(
        prepareMessageFromParams(t("error_message_required"), [
          ["fieldName", t("folder_name")],
        ])
      )
      .max(
        50,
        prepareMessageFromParams(t("error_message_max_length"), [
          ["fieldName", t("folder_name")],
          ["max", "50"],
        ])
      )
      .min(
        2,
        prepareMessageFromParams(t("error_message_min_length"), [
          ["fieldName", t("folder_name")],
          ["min", "2"],
        ])
      ),

    gender: Yup.string().required(
      prepareMessageFromParams(t("error_message_required"), [
        ["fieldName", t("gender")],
      ])
    ),
  });

export const fetchGalleryDirectoryById = async (
  id: string,
  handleClose: (status: boolean) => void
) => {
  try {
    const galleryDirectory = await GET_GALLERY_DIRECTORY_BY_ID(id);
    if (
      galleryDirectory &&
      galleryDirectory.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      return galleryDirectory.data;
    } else {
      handleClose(false);
      sweetAlertError({
        message: galleryDirectory.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
      return undefined;
    }
  } catch (e: any) {
    handleClose(false);
    handleError(e, "fetchGalleryDirectoryById");
  }
};

export const handleSubmitGalleryDirectory = async (
  values: IGalleryDirectoryData,
  setLoading: TReactSetState<boolean>,
  id: string | undefined,
  handleClose: (status: boolean) => void
) => {
  setLoading(true);
  try {
    let resultGalleryDirectory;
    if (id) {
      resultGalleryDirectory = await UPDATE_GALLERY_DIRECTORY(values, id);
    } else {
      resultGalleryDirectory = await CREATE_GALLERY_DIRECTORY(values);
    }
    if (
      resultGalleryDirectory &&
      resultGalleryDirectory.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      sweetAlertSuccess({
        message: resultGalleryDirectory.message,
      });
      return handleClose(true);
    } else {
      sweetAlertError({
        message:
          resultGalleryDirectory?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (e: any) {
    handleError(e, "handleSubmitGalleryDirectory");
  } finally {
    setLoading(false);
  }
};
